import {Empty} from "antd";

const SettingsPage = () => {
  return <div style={{justifyContent: 'center', display: 'flex', height: '100%', alignItems: 'center'}}>
    <Empty description={'Данные пока отсутствуют'}/>
  </div>
}

export default SettingsPage;
